import { Activity } from "../../components/activity/types";
import { ChequeSearchProperties } from "../../components/cheque/cheque-search-form/types";
import { useDashboardStore } from "../../stores";
import { Cheque, ChequeUpdate } from "../../types";
import Api from "../api";
import { createFormData, getFileHeaders, parseApiData } from "../utils";

class ChequeApi extends Api {
  static search(cheque: ChequeSearchProperties): Promise<Array<Cheque>> {
    return this.postData(
      "/cheque/search",
      parseApiData({
        name: cheque.name,
        number: cheque.number,
        account_no: cheque.account_no,
        bank: cheque.bank?.name,
        price: cheque.price,
        shenase: cheque.shenase,
        from_date: cheque.fromDate,
        to_date: cheque.toDate,
        confirmed_with: cheque.confirmedWith,
        status: cheque.status?.status,
      })
    );
  }

  static update(cheque: ChequeUpdate, id: string): Promise<Cheque> {
    const headers = getFileHeaders(cheque.image);

    return new Promise((resolve, reject) => {
      this.patchData<Cheque, unknown>(
        `/cheque/${id}`,
        createFormData({
          name: cheque.name,
          number: cheque.number,
          shenase: cheque.shenase,
          bank: cheque.bank?.name,
          account_no: cheque.account_no,
          price: cheque.price,
          date: cheque.date,
          confirmed_with: cheque.confirmed_with,
          image: cheque.image?.length ? cheque.image[0] : null,
        }),
        { headers }
      )
        .then((res) => {
          useDashboardStore.getState().activitiesAdd(res.activities[0]);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  static deleteCheque(id: string): Promise<void> {
    return new Promise((resolve, reject) => {
      this.deleteData<Activity>(`/cheque/${id}`)
        .then((res) => {
          useDashboardStore.getState().activitiesAdd(res);
          resolve();
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  static confirm(id: string, confirmed_with: string): Promise<Cheque> {
    return new Promise((resolve, reject) => {
      this.postData<Cheque, unknown>(`/cheque/confirm/${id}`, {
        confirmed_with,
      })
        .then((res) => {
          useDashboardStore.getState().activitiesAdd(res.activities[0]);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  static deliver(id: string): Promise<Cheque> {
    return new Promise((resolve, reject) => {
      this.postData<Cheque, unknown>(`/cheque/deliver/${id}`)
        .then((res) => {
          useDashboardStore.getState().activitiesAdd(res.activities[0]);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  static getById(id: string): Promise<Cheque> {
    return this.getData(`/cheque/${id}`);
  }
}

export default ChequeApi;
